import { Link } from 'react-router-dom';
import {
  HomeRoot,
  HomeInner,
  ContentWrap,
  TitleWrap,
  WelcomeText,
  BrandMarkWrap,
  BrandMark,
  CopyWrap,
  CopyText,
  EmOrder,
  EmX,
  ButtonRow,
  PrimaryBtn,
  OutlineBtn,
  ImageWrap,
  HeroImage,
} from '../../components/StyledComponents/Home.styles';
import WelcomeImg from '../../assets/images/Welcome.png';
import OrderXProfileImg from '../../assets/images/OrderXProfile.png';
import { routeURL } from 'src/utils/properties.utils';

export default function Home() {
  return (
    <HomeRoot>
      <HomeInner>
        <ContentWrap>
          <TitleWrap>
            <WelcomeText>Welcome to</WelcomeText>
            <BrandMarkWrap>
              <BrandMark src={WelcomeImg} alt="ORDERX" />
            </BrandMarkWrap>
          </TitleWrap>
          <CopyWrap>
            <CopyText>
              Transform the way you manage manufacturing with{' '}
              <EmOrder>Order</EmOrder>
              <EmX>X</EmX>. Our all-in-one platform brings every step of your
              operation together—from purchasing raw materials to producing and
              delivering finished goods—so you can ditch messy spreadsheets and
              disconnected systems. Easily issue purchase orders, log receipts,
              approve payments, track orders through fulfillment and monitor
              production quality in real time.
            </CopyText>
            <CopyText>
              With unified vendor and customer directories, live inventory and
              pricing data, and secure role-based access,{' '}
              <EmOrder>Order</EmOrder>
              <EmX>X</EmX> keeps your team aligned and your business moving
              faster. Streamline workflows, gain clarity and stay in control—all
              with a solution built for growth.
            </CopyText>
          </CopyWrap>
          <ButtonRow>
            <PrimaryBtn href={routeURL.LOGIN} aria-label="Login">
              Login
            </PrimaryBtn>
            <OutlineBtn href={routeURL.SIGN_UP} aria-label="Sign up">
              Sign up
            </OutlineBtn>
          </ButtonRow>
        </ContentWrap>
        <ImageWrap>
          <Link to="/" aria-label="OrderX">
            <HeroImage src={OrderXProfileImg} alt="OrderX" />
          </Link>
        </ImageWrap>
      </HomeInner>
    </HomeRoot>
  );
}
